<template>
<div id="CdssSearch">
<CdssSearch :AllowEdit="true"/>
</div>
</template>

<script>
import Vue from 'vue';
import CdssSearch from '@/components/DPEBB/Administrator/CdssSearch.vue'; 
import LayoutDefault from '@/Common/Default/DefaultLayout.vue';
export default {

data: function () {
    return {
        AppServiceID :6,
        }
    },
 components: {
        CdssSearch
    },
   created: function() {
            this.$emit('update:layout', LayoutDefault);
    },
    beforeCreate: function() {
        this.$store.dispatch('AddServiceID',this.$store.getters.GetDPEBBServiceID);
        this.$store.dispatch('GetMenuItems',this.$store.getters.GetDPEBBServiceID);
    } 
}
</script>